import { render, staticRenderFns } from "./type-statements.vue?vue&type=template&id=292925b6"
import script from "./type-statements.vue?vue&type=script&lang=js"
export * from "./type-statements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports